export default __webpack_public_path__ + "static/media/work_web-sm@2x.a2b975ad.jpg";